'use client';
import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.804 14.213a17.26 17.26 0 0 0-7.567.18l-.237.06a18.3 18.3 0 0 1-8.043.19l-.153-.03a1 1 0 0 1-.804-.98V2.793a1 1 0 0 1 1.196-.98c2.505.5 5.089.439 7.567-.18l.473-.118a17.26 17.26 0 0 1 7.567-.18l.392.078a1 1 0 0 1 .805.98v10.84a1 1 0 0 1-1.196.98",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 10.014a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgMoney as default };
//# sourceMappingURL=money.svg.js.map
